export class S3SampleFileResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "format",
            "baseName": "format",
            "type": "string",
            "format": ""
        },
        {
            "name": "schema",
            "baseName": "schema",
            "type": "Array<SchemaField>",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<{ [key: string]: any; }>",
            "format": ""
        },
        {
            "name": "parsedRows",
            "baseName": "parsedRows",
            "type": "number",
            "format": ""
        },
        {
            "name": "totalRowsInFile",
            "baseName": "totalRowsInFile",
            "type": "number",
            "format": ""
        },
        {
            "name": "stats",
            "baseName": "stats",
            "type": "S3FileSampleStats",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3SampleFileResponse.attributeTypeMap;
    }
    constructor() {
    }
}
